import classNames from 'classnames';
import * as React from 'react';

export interface SegmentedControlOption {
    value: string;
    label: string;
    glyph?: string;
}

export interface SegmentedControlProps {
    options: SegmentedControlOption[];
    value: string;
    onChange: (value: string) => void;
    ariaLabel: string;
    disabled?: boolean;
    className?: string;
}

export const SegmentedControl: React.FunctionComponent<SegmentedControlProps> = ({options, value, onChange, ariaLabel, disabled, className}: SegmentedControlProps) => (
    <div role="group" aria-label={ariaLabel} className={classNames('mp-segmented', className)}>
        {options.map(option => (
            <button
                key={option.value}
                type="button"
                className="mp-segmented__option"
                aria-pressed={option.value === value}
                disabled={disabled}
                onClick={() => onChange(option.value)}
            >
                {option.glyph && <span className="mp-segmented__glyph" aria-hidden="true">{option.glyph}</span>}
                {option.label}
            </button>
        ))}
    </div>
);
